/*
 * Created Date: Thursday October 27th 2022
 * Author: Oskar Karnblad
 * License: Proprietary to Scaffcalc AB
 *
 * Copyright (c) 2022 Scaffcalc AB
 */
import React, { FC } from "react";
import "@fontsource/roboto";

import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";

export interface CheckboxCustomInterface {
  label: string;
  disabled: boolean;
  onChange: (event: any) => void;
  checked: boolean;
}

const CheckboxCustom: FC<CheckboxCustomInterface> = ({
  label,
  disabled,
  onChange,
  checked,
}) => {
  return (
    <FormGroup>
      <FormControlLabel
        checked={checked}
        disabled={disabled}
        control={<Checkbox />}
        label={label}
        onChange={(e) => {
          onChange(e);
        }}
        sx={{
          "& .MuiSvgIcon-root": {
            color: "text.primary",
          },
          color: "text.primary",
          userSelect: "none",
        }}
      />
    </FormGroup>
  );
};

CheckboxCustom.defaultProps = {
  disabled: false,
  label: "Checkbox",
  onChange: () => {},
  checked: false,
};

export default CheckboxCustom;
